"use client";
import { File04Icon as e } from "../icons/File04Icon.js";
import { Link03Icon as t } from "../icons/Link03Icon.js";
import { Popover as n } from "../popover/Popover.js";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/fields/FieldSource.tsx
function i({ config: i }) {
	return /* @__PURE__ */ r(n, {
		mode: "preview",
		title: i.label,
		positionConfig: {
			side: i.side ?? "top",
			align: "start"
		},
		trigger: /* @__PURE__ */ r("button", {
			type: "button",
			"aria-label": `Open source: ${i.label}`,
			onClick: i.onOpen,
			className: "pf:flex pf:size-lg pf:shrink-0 pf:items-center pf:justify-center pf:border-0 pf:rounded-xs pf:p-0 pf:bg-transparent pf:text-soft-pearl-600 pf:hover:text-soft-pearl-800 pf:focus-visible:outline-2 pf:focus-visible:outline-blue-700",
			children: i.kind === "document" ? /* @__PURE__ */ r(e, {
				size: 12,
				tone: "inherit"
			}) : /* @__PURE__ */ r(t, {
				size: 12,
				tone: "inherit"
			})
		}),
		children: i.preview
	});
}
//#endregion
export { i as FieldSource };
